module.exports = __webpack_public_path__ + "media/components/country-flag/static/bf-a401476cea39fcc1085ee72a6119fe51.svg";